import Attract from "../../images/ewicons/attract.png";
import Brain from "../../images/ewicons/brain.png";
import Pen from "../../images/ewicons/pen.png";
import People from "../../images/ewicons/people.png";
import Serve from "../../images/ewicons/ServeIcon.png";



export const icon=[
{

 id:1,
 title:`Assess`,
 text:"We partner with you to identify crucial skill competencies, ensuring candidates have the traits needed to thrive in your organization.",
 img:Pen,
 imgt:"Paper and Pen"
    
},


{
 id:2,
 title:`Attract`,
 text:"Using market expertise, our recruiters proactively build candidate networks all day, every day.",    
 img:Attract,
 imgt:"a person in atom"

},

{
 id:3,
 title: `Evaluate`,
 text:"Our recruiters dig deep. From soft skills to hard skills, Expedient evaluates beyond a resume.",  
 img:Brain,
 imgt:"an image in a brain"
},

{
 id:4,
 title: `Select`,
 text:"Time is a valuable resource. When meeting a candidate, rest assured we’ve selected talent that fits your culture.",  
 img:People,
 imgt:" an illsutrator of people"
},

{

 id:5,
 title:`Serve`,
 text:"The staffing life cycle doesn’t end when you hire the perfect candidate. We stay in touch to ensure new hires hit the ground running.", 
 img:Serve,
 imgt:" three arrows in a circle"

    },
];
